import React from "react";
import { Link } from "react-router-dom";

const count = (total?: number, left?: number) => (total ? (left != null ? `${left} of ${total} remaining` : `Edition of ${total}`) : "");

export function editionInfo(p: any): { label: string; note: string } | null {
  if (p?.limited_edition) return { label: "Limited Edition", note: count(p.edition_total, p.edition_remaining) };
  if (p?.atelier_edition) return { label: "Atelier Edition", note: count(p.atelier_edition_total, p.atelier_edition_remaining) };
  return null;
}

export function EditionInfo({ p }: { p: any }) {
  const ed = editionInfo(p);
  const eds = p.editions || [];
  if (!ed && !eds.length && !p.collection_name) return null;
  return (
    <div className="mt-6 border-l-2 border-[var(--c-primary)] pl-4 py-1 space-y-1.5" data-testid="product-edition-info">
      {ed && <p className="eyebrow text-[var(--c-primary)]" data-testid="product-edition-label">{ed.label}</p>}
      {ed?.note && <p className="text-sm" data-testid="product-edition-note">{ed.note}</p>}
      {p.collection_name && (
        <p className="text-sm text-neutral-600" data-testid="product-collection-name">
          Part of the{" "}
          {p.lookbook_collection ? <Link to={`/collections/${p.lookbook_collection.slug}`} className="underline hover:text-neutral-900" data-testid="product-collection-link">{p.lookbook_collection.title}</Link> : p.collection_name}
          {/collection$/i.test(p.lookbook_collection?.title || p.collection_name) ? "" : " collection"}
        </p>
      )}
      {eds.length > 0 && (
        <p className="text-xs text-neutral-500">
          View all{" "}
          {eds.map((e: any, i: number) => (
            <React.Fragment key={e.slug}>{i > 0 && " · "}<Link to={`/collections/${e.slug}`} className="underline hover:text-neutral-900" data-testid={`product-edition-link-${e.slug}`}>{e.title}</Link></React.Fragment>
          ))}
        </p>
      )}
    </div>
  );
}
